import api from './api';
import { assertCurrentSession, captureSession } from '../utils/authSession';

const authService = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  distributorLogin: (username, password) =>
    api.post('/auth/distributor/login', { username, password }),
  refreshToken: (refreshToken) => api.post('/auth/refresh-token', { refreshToken }),
  async changePassword(currentPassword, newPassword, session = captureSession()) {
    assertCurrentSession(session);
    const response = await api.post(
      '/auth/change-password',
      { currentPassword, newPassword },
      {
        sessionBinding: session,
        skipAuthReplay: true,
        timeout: 20000,
      }
    );
    assertCurrentSession(session);
    const result = response?.data;
    if (
      result?.success !== true ||
      !result.data ||
      typeof result.data !== 'object' ||
      Array.isArray(result.data)
    ) {
      throw new Error('Your password change could not be confirmed. Please sign in again.');
    }
    return response;
  },
};

export default authService;
